import { proxy } from 'valtio';

import { type BoardId } from '@canvas/model/board';
import { type VersionId } from '@canvas/model/version';

export const currentRouteState: { boardId?: BoardId; versionId?: VersionId } = proxy({
  boardId: undefined,
  versionId: undefined,
});
